// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import styles from './woops_payment.module.less';
import {Button} from '../lib/button';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';

export const Susp_payment_hola2023 = ({on_close}: {on_close: ()=>void})=>{
  const {theme} = useContext(Settings_context);
  return <div className={cn(styles.root_hola2023, styles.susp)}>
    <p className={cn(theme.p2, theme.bold, styles.title)}>
      Suspicious Activity
    </p>
    <p className={cn(theme.p3)}>
      You have been flagged due to chargeback abuse. As such, we will not
      allow you to purchase any new subscriptions.
    </p>
    <Button on_click={on_close} caption="OK" color="white"/>
  </div>;
};

export const Susp_payment = ({on_close}: {on_close: ()=>void})=>{
    return <div className={styles.root}>
      <img src={'/cms/wp-content/uploads/2023/09/susp.png'} alt="suspicious"
        className={cn(styles.img, 'lazyload')} width={148} height={120}/>
      <h3>Suspicious Activity</h3>
      <p>We're sorry but we can't process your payment. Please contact our
        support for assistance (error code:805)</p>
      <Button on_click={on_close} caption={'OK'} size={'sm'}
        color={'white'} cls={styles.btn}/>
    </div>;
};
